import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['button'];

  connect() {
    window.addEventListener("resize", (event) => { this.renderMobileNav() });
    this.renderMobileNav()
  }

  // everytime viewwidth is below 1029px, the mobile nav will be rendered
  renderMobileNav() {
    const mobileNavPlaceholder = document.getElementById('mobile-nav-placeholder')

    // console.log(mobileNavPlaceholder);.renderMobileN.renderMobileNav
    if (mobileNavPlaceholder && window.innerWidth < 1029) {
      mobileNavPlaceholder.innerHTML = this.buttonTarget.innerHTML
    } else if (mobileNavPlaceholder) {
      mobileNavPlaceholder.innerHTML = ""
    }
  }
}
